import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { TreePine, Loader2 } from 'lucide-react';
import { formatApiError } from '@/lib/api';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(email, password);
      const dest = user.role === 'owner' ? '/admin' : user.role === 'manager' ? '/manager' : '/cleaner';
      navigate(dest);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || 'Login failed');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center px-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <TreePine className="w-8 h-8 text-[#1E3F33]" />
          </div>
          <h1 className="text-3xl font-heading font-medium text-[#1F2A25]">Staff Login</h1>
          <p className="text-sm text-[#6B726A] mt-1">Sign in to manage bookings</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white border border-[#E6D5B8] p-8 rounded-xl shadow-[0_8px_30px_rgba(30,63,51,0.04)]">
          {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded" data-testid="login-error">{error}</div>}

          <div className="space-y-4">
            <div>
              <Label className="text-sm text-[#1F2A25]">Email</Label>
              <Input value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder="admin@newforestcaravans.co.uk" className="mt-1 border-[#E6D5B8] focus:border-[#1E3F33]" required data-testid="login-email-input" />
            </div>
            <div>
              <Label className="text-sm text-[#1F2A25]">Password</Label>
              <Input value={password} onChange={e => setPassword(e.target.value)} type="password" placeholder="Enter password" className="mt-1 border-[#E6D5B8] focus:border-[#1E3F33]" required data-testid="login-password-input" />
            </div>
          </div>

          <Button type="submit" disabled={loading} className="w-full mt-6 bg-[#CC5A3D] text-[#F9F8F6] hover:bg-[#B34A30] rounded-sm py-3" data-testid="login-submit-btn">
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>
      </div>
    </div>
  );
}
